'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var _reactIntl = require('react-intl');

var _reactRouterRedux = require('react-router-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('../../components');

var _EmailInput = require('../../components/EmailInput/EmailInput');

var _Captcha = require('../../helpers/Captcha');

var _DefaultString = require('../../helpers/DefaultString');

var _Error = require('../../helpers/Error');

var _NeutralBrandingRoutes = require('../../helpers/NeutralBrandingRoutes');

var _PopupType = require('../../helpers/PopupType');

var _Router = require('../../helpers/Router');

var _auth = require('../../redux/modules/auth');

var _popup = require('../../redux/modules/popup');

var _ForgotPassword = require('./ForgotPassword.scss');

var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validator = require('email-validator');

var ForgotPassword = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    auth: state.auth,
    captcha: state.captcha,
    captchaToken: state.captcha.captchaToken,
    lang: state.auth.lang };
}, { changePopupType: _popup.changePopupType, editEmailMessageError: _auth.editEmailMessageError, forgotPassword: _auth.forgotPassword, pushState: _reactRouterRedux.push }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ForgotPassword, _Component);

  function ForgotPassword() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ForgotPassword);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ForgotPassword.__proto__ || (0, _getPrototypeOf2.default)(ForgotPassword)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      captchaError: false,
      emailFieldError: false,
      loading: false
    }, _this.editCaptchaError = function (captchaError) {
      _this.setState({ captchaError: captchaError });
    }, _this.handleEnterKey = function (event) {
      if (event.key === 'Enter') {
        _this.submitForgotPassword();
      }
    }, _this.validateEmail = function (email) {
      var isEmailValid = validator.validate(email);
      _this.props.editEmailMessageError(!isEmailValid ? _EmailInput.EmailErrorMessage.InvalidEmail : null);
      return isEmailValid;
    }, _this.submitForgotPassword = function () {
      if (_this.validateEmail(_this.props.auth.email)) {
        _this.captchaEl.getWrappedInstance().executeReCaptcha();
      }
    }, _this.reCaptchaValidated = function (captchaToken) {
      if (captchaToken) {
        var resetPasswordUri = window.location.protocol + '//' + window.location.host + (0, _Router.getPathForEmailLink)(_Router.RouterConst.ValidateResetPassword, _this.props.lang);
        _this.props.forgotPassword(_this.props.auth.email, _this.props.lang, resetPasswordUri);
        _this.setState({ loading: true });
      } else {
        _this.editCaptchaError(true);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ForgotPassword, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.auth.forgotPassword && !nextProps.auth.forgotPassword) {
        if (!nextProps.auth.forgotPasswordError) {
          if (!nextProps.auth.response.emailExists) {
            this.props.editEmailMessageError(_EmailInput.EmailErrorMessage.InvalidEmail);
          } else if (nextProps.auth.response.emailExists) {
            this.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + _Router.RouterConst.ConfirmForgotPassword));
          }
        } else if (nextProps.auth.forgotPasswordError && !nextProps.auth.forgotPasswordError.response || nextProps.auth.forgotPasswordError.response.body.code !== _Error.ErrorConst.InvalidCaptcha) {
          this.props.changePopupType(_PopupType.PopupId.UnknownError);
        }
        this.setState({ loading: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var isSubmitInactive = !!this.props.auth.emailErrorMessage || this.props.auth.captchaError;
      var isNeutralRoute = (0, _NeutralBrandingRoutes.isNeutralBrandingRoute)(this.context.router.location.pathname);

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_ForgotPassword2.default.forgotPassword, { stingrayCorpo: isNeutralRoute }) },
        _react2.default.createElement(
          _components.DialogCard,
          {
            title: _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.PasswordResetTitle),
            message: _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.ForgotPasswordMessage)
          },
          _react2.default.createElement(
            _reactBootstrap.FormGroup,
            { role: 'form' },
            _react2.default.createElement(_components.EmailInput, {
              intl: this.props.intl,
              handleEnterKey: this.handleEnterKey,
              placeholder: _DefaultString.translations.EmailAddress
            }),
            _react2.default.createElement(_components.Captcha, {
              ref: function ref(el) {
                _this2.captchaEl = el;
              },
              error: this.state.captchaError,
              editCaptchaError: this.editCaptchaError,
              captchaTypeRequired: ForgotPassword.beCalls,
              onReCaptchaValidated: this.reCaptchaValidated
            }),
            _react2.default.createElement(
              'div',
              { className: _ForgotPassword2.default.buttonContainer },
              _react2.default.createElement(_components.BaseButton, {
                className: _ForgotPassword2.default.button,
                onClick: this.submitForgotPassword,
                buttonString: _DefaultString.translations.Submit,
                isInactive: isSubmitInactive,
                loading: this.state.loading
              })
            )
          )
        ),
        _react2.default.createElement(_components.BrandLogos, null)
      );
    }
  }]);
  return ForgotPassword;
}(_react.Component), _class2.propTypes = {
  auth: _react.PropTypes.object,
  captcha: _react.PropTypes.object,
  captchaToken: _react.PropTypes.string,
  changePopupType: _react.PropTypes.func,
  editEmailMessageError: _react.PropTypes.func,
  intl: _reactIntl.intlShape.isRequired,
  lang: _react.PropTypes.string,
  forgotPassword: _react.PropTypes.func,
  pushState: _react.PropTypes.func.isRequired
}, _class2.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
}, _class2.beCalls = [_Captcha.CaptchaCallNames.ForgotPassword], _temp2)) || _class);
exports.default = (0, _reactIntl.injectIntl)(ForgotPassword);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ForgotPassword/ForgotPassword.js
// module id = 2007
// module chunks = 0